import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button, IconButton } from '@dopomogai/ui';
import { Play, Download, Settings, PanelLeft, ArrowLeft, Plus } from 'lucide-react';

export interface HeaderProps {
  currentView: 'list' | 'builder';
  presentationTitle?: string;
  hasUnsavedChanges?: boolean;
  onAction: (action: 'togglePreview' | 'export' | 'settings' | 'toggleSidebar' | 'new' | 'back') => void;
}

export const Header: React.FC<HeaderProps> = ({
  currentView,
  presentationTitle,
  hasUnsavedChanges,
  onAction,
}) => {
  const { t } = useTranslation(['header', 'common']);

  return (
    <header className="sticky top-0 z-30 bg-white/90 backdrop-blur-md border-b-2 border-black">
      <div className="container mx-auto flex h-20 items-center justify-between px-4 sm:px-6">
        <div className="flex items-center gap-4 sm:gap-6">
          {currentView === 'builder' ? (
            <IconButton
              icon={<ArrowLeft size={18} />}
              variant="secondary"
              onClick={() => onAction('back')}
              ariaLabel="Back to Presentations" // FIX
            />
          ) : (
            <h1 className="text-xl font-bold text-slate-900">AI Presenter</h1>
          )}
          {currentView === 'builder' && (
            <>
              <div className="h-8 w-px bg-slate-300" />
              <IconButton
                  icon={<PanelLeft size={18} />}
                  variant="ghost"
                  onClick={() => onAction('toggleSidebar')}
                  ariaLabel="Toggle Slides Panel" // FIX
              />
              <div>
                <h1 className="text-lg font-bold text-slate-800 truncate max-w-xs">{presentationTitle || 'Untitled'}</h1>
              </div>
            </>
          )}
        </div>
        <div className="flex items-center gap-2">
          {currentView === 'list' && (
            <Button variant="primary" onClick={() => onAction('new')} icon={<Plus size={16} />} text="New Presentation" />
          )}
          {currentView === 'builder' && (
            <>
              <Button variant="primary" onClick={() => onAction('togglePreview')} icon={<Play size={16} />} text={t('present_mode')} className="hidden sm:flex" />
              <IconButton icon={<Play size={18} />} onClick={() => onAction('togglePreview')} ariaLabel={t('present_mode')} className="sm:hidden" /> {/* FIX */}
              <div className="h-6 w-px bg-slate-300 mx-1"></div>
              <IconButton icon={<Download size={18} />} variant="ghost" onClick={() => onAction('export')} ariaLabel="Export" /> {/* FIX */}
              <IconButton icon={<Settings size={18} />} variant="ghost" onClick={() => onAction('settings')} ariaLabel="Settings" /> {/* FIX */}
            </>
          )}
        </div>
      </div>
    </header>
  );
};